module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan1-2-b66af9b58df715ba5746213c27d65df7.webp";